import { useEffect, useRef } from "react";

export const useScrollOnMessage = (message?: string) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (message && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [message]);

  return ref;
};
